import { RoleType, RoleEditType } from "./RoleType";
import { Modal } from '../../components'
import { useState } from "react";
import {Form, Input,message} from 'antd';
import { useTranslation } from "../../hooks/useTranslation";
import { useSelector } from "../../hooks/useSelector";
import { useRequest } from "../../hooks/useRequest";
import { api } from "../../config/api";

export const RoleEdit : React.FC<RoleEditType> = ({type, role, onClose}) =>{

    // const [parentId1, setParentId1] = useState(parentId || 0);
    const [enable, setEnable] = useState(true);
    const t = useTranslation();
    const [form] = Form.useForm();
    const setting = useSelector(state => state.setting);
    const {json} = useRequest();

    const handleClose = () => {
        setEnable(false);
        setTimeout(() => {
            onClose(false);
        }, 500);
    }

    const onFinishFailed = () => {
        message.warning({
            content: t('请确认数据正确后在提交'),
        });
    };

    const onFinish = (values: RoleType) => {
        // console.log(values);
        let data: RoleType = {...role, ...values}
        // console.log(data);
        let url = data.id?api.role.update:api.role.add;
        
        let update = async() => {
            let result = await json.post(url, data);
            message.success(t(result.msg));
            if(result.status){
                setEnable(false);
                onClose(true);
            }
        }

        update();
    };
    
    const formHtml = (
        <div className="edit-form-wrap">
            <Form<RoleType> form={form} labelCol={{span: 6}} wrapperCol={{span:18}} 
                size={setting.size}
                onFinishFailed={onFinishFailed}
                onFinish={onFinish}
            >   
                <Form.Item
                    label={t('角色显示名')}
                    name="label"
                    initialValue={role.label}
                    rules={[{ required: true, message:  t("角色显示名")}]}
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    label={t('角色名')}
                    name="name"
                    initialValue={role.name}
                    rules={[{ required: true, message:  t("角色名不能为空")}]}
                >
                    <Input />
                </Form.Item>
            </Form>
        </div>
    );

    let title = type==1?t('新增角色') : t('编辑角色')
        
    return (
        <Modal visible={enable}
            title={title}
            onOk={()=>{form.submit()}}
            onCancel={()=>handleClose()}
            afterClose={()=>handleClose()}
        >
            {formHtml}
        </Modal>
    )
} 